import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Geocode from "react-geocode";
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import GPSFixedIcon from '@material-ui/icons/GpsFixed';
import GPSNotFixedIcon from '@material-ui/icons/GpsNotFixed';
import {API} from 'aws-amplify';

// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }

function getModalStyle() {
  const top = 50;// + rand();
  const left = 50;// + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    /*boxShadow: theme.shadows[4],*/
    padding: theme.spacing.unit * 4,
  },
  smallIcon: {
    width: 20,
    height: 20,
  },
  zip: {
    paddingLeft: '5px',
  },
  button: {
    //color: theme.palette.primary.main,
  }
});

const DEFAULT_ZIP = '90210';

class ZipModal extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      open: false,
      zip: DEFAULT_ZIP,
      loading: true,
    };
    //TODO: probably will need to remove the following two lines
    //sessionStorage.setItem('country', '');
    //sessionStorage.setItem('zip', '');

    this.updateInput = this.updateInput.bind(this);
    this.geoSuccess = this.geoSuccess.bind(this);
    this.geoError = this.geoError.bind(this);
    this.handleLeasyZipChange = this.handleLeasyZipChange.bind(this);
    Geocode.setApiKey("AIzaSyAYX1cyouv8vK7zJ-AuBtOIHQgZ5Lvr0tE");
    Geocode.enableDebug();
    //distance matrix API key: AIzaSyCP7oJegPsSanWlVrGsSXwa6a2biQiXSQ8

    if (sessionStorage.getItem('zip') == null)  {
      //navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
      this.geoLocate();
    } else {
      //console.log('zip already set');
      this.getLeasyZip(sessionStorage.getItem('zip'));
    }

  }

  geoLocate() {
    // let ip = "137.25.185.108"
    // let api_key = "?api-key=21a4df4b1b3e452803487f0fea7cdd74e3ec1c05bd8a6c9759029466"
    // console.log('now trying to geoLocate');
    // API.get('ipdata','/' + api_key)
    //     .then(data => {
    //       console.log(data);
    //     })
    //     .catch (err => console.log(err))
    fetch("https://api.ipdata.co?api-key=21a4df4b1b3e452803487f0fea7cdd74e3ec1c05bd8a6c9759029466")
      .then(response => {
        return response.json();
       }, "jsonp")
      .then(res => {
        console.log(res.postal.length);
        if(res.postal.length === 5) {
          sessionStorage.setItem('country', res.country_code);
          sessionStorage.setItem('zip', res.postal);
          if(res.country_code === 'US') {
            this.getLeasyZip(res.postal);
          } else {
            //TODO: set some banner message perhaps
          }
        } else {
          console.log('could not geoLocate.');
          navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
        }

      })
      .catch(err => {
        console.log(err);
        navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
      });
 }

  geoSuccess(position) {
    //console.log('index coords: ' + position.coords.latitude + ' ' + position.coords.longitude);
    Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
      response => {
        let zip = '';
        let country = '';
        //const address = response.results[0].formatted_address;
        for (let address_component of response.results[0].address_components) {
          for (let type of address_component.types){
            if (type === 'postal_code') {
              zip = address_component.long_name;
            } else if (type === 'country') {
              country = address_component.short_name;
            }
          }
        }
        //const zip = response.results[0].;
        sessionStorage.setItem('country', country);
        sessionStorage.setItem('zip', zip);
        if(country === 'US') {
          this.getLeasyZip(zip)
        } else {
          //TODO: set some banner message perhaps
        }
        //console.log('country: ' + country + ' zip: ' + zip);

      },
      error => {
        console.error(error);
        this.setState({ open: true, zip: DEFAULT_ZIP, loading: false })
      }
    );
  }

  geoError() {
    this.setState({ open: true, zip: DEFAULT_ZIP, loading: false })
    console.log("Sorry, no position available.");
  }

  //translate userZip to leasyZip
  getLeasyZip = async (zip) => {
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'zip': zip
        }
    }

    API.post('leasy','/get-leasy-zip', requestParams)
        .then(data => {
          //console.log(data);
          let newLeasyZip = '';
          if ('errorType' in data)  { //most probably we don't have a leasyZip for this user ZipModal
            newLeasyZip = DEFAULT_ZIP;
          } else {
            newLeasyZip = data.leasyZip;
          }
          this.setState({ open: false, zip: sessionStorage.getItem('zip'), loading: false })
          this.handleLeasyZipChange(newLeasyZip);
          return data;
        })
        .catch (err => console.log(err))
  }

  componentWillMount() {
      //console.log('componentWillMount for ZipModal');
      //console.log('zip: ' + sessionStorage.getItem('zip'));
      sessionStorage.getItem('zip') ? this.setState({ open: false, zip: sessionStorage.getItem('zip') }) : this.setState({ open: true});
  }

  handleLeasyZipChange(newLeasyZip) {
    this.props.onLeasyZipChange(newLeasyZip)
  }

  handleOpen = () => {
    this.setState({ open: true, loading: false });
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.state.zip !== sessionStorage.getItem('zip')) {
      //here we use the user zip to get the "leasy" zip and then save it in the session as 'leasyZip'
      sessionStorage.setItem('country', 'US');
      sessionStorage.setItem('zip', this.state.zip);
      this.getLeasyZip(this.state.zip)
    }
  };

  updateInput(event){
    this.setState({zip : event.target.value})
  }

  render() {
    const { classes } = this.props;
    const { loading } = this.state;

    return (
      <div>
        <Button className={classes.button} onClick={this.handleOpen}>
          {
            (this.state.zip)
            ?  <GPSFixedIcon className={classes.smallIcon}/>
          :  <GPSNotFixedIcon className={classes.smallIcon}/>
          }
          <div className={classes.zip}>
            {this.state.zip}
          </div>

        </Button>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <Grid container alignItems="stretch" justify="center" spacing={16}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="title" id="modal-title">
                  So we can show you deals near you...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  onChange={this.updateInput}
                  id="uncontrolled"
                  label="Please enter your zip code:"
                  defaultValue={this.state.zip}
                  className={classes.textField}
                  fullWidth
                  margin="normal"
                />
                <Fade
                  in={loading}
                  style={{
                    transitionDelay: loading ? '800ms' : '0ms',
                  }}
                  unmountOnExit
                >
                  <CircularProgress className={classes.progress} />
                </Fade>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}/>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}/>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                <Button variant="raised" color="primary" onClick={this.handleClose}>Ok</Button>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                <Button onClick={this.handleClose}>Cancel</Button>
              </Grid>
            </Grid>
          </div>
        </Modal>
      </div>
    );
  }
}

ZipModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

// We need an intermediary variable for handling the recursive nesting.
const ZipModalWrapped = withStyles(styles)(ZipModal);

export default ZipModalWrapped;



// WEBPACK FOOTER //
// ./src/components/dashboard/ZipModal.jsx